import { useEffect, useRef } from "react";
import { useOptionalNavigation } from "./link/useLoadedNavigation";
function useFocusEffect(effect) {
  var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var navigation = useOptionalNavigation();
  var prevDepsRef = useRef(deps);
  var depsCountRef = useRef(0);
  if (!Array.isArray(deps) || !Array.isArray(prevDepsRef.current) || prevDepsRef.current.length !== deps.length || prevDepsRef.current.some(function(d, i) {
    return !Object.is(d, deps[i]);
  })) {
    prevDepsRef.current = deps;
    depsCountRef.current++;
  }
  useEffect(function() {
    if (!navigation) {
      return;
    }
    var isFocused = false;
    var cleanup;
    var callback = function callback2() {
      var destroy = effect();
      if (destroy === void 0 || typeof destroy === "function") {
        return destroy;
      }
      if (process.env.NODE_ENV !== "production") {
        var message = "An effect function must not return anything besides a function, which is used for clean-up.";
        if (destroy === null) {
          message += " You returned 'null'. If your effect does not require clean-up, return 'undefined' (or nothing).";
        } else if (typeof destroy.then === "function") {
          message += "\n\nIt looks like you wrote 'useFocusEffect(async () => ...)' or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseFocusEffect(\n  React.useCallback(() => {\n    async function fetchData() {\n      // You can await here\n      const response = await MyAPI.getData(someId);\n      // ...\n    }\n\n    fetchData();\n  }, [someId])\n);\n\nSee usage guide: https://reactnavigation.org/docs/use-focus-effect";
        } else {
          message += ` You returned '${JSON.stringify(destroy)}'.`;
        }
        console.error(message);
      }
    };
    if (navigation.isFocused()) {
      cleanup = callback();
      isFocused = true;
    }
    var unsubscribeFocus = navigation.addListener("focus", function() {
      if (isFocused) return;
      cleanup === null || cleanup === void 0 ? void 0 : cleanup();
      cleanup = callback();
      isFocused = true;
    });
    var unsubscribeBlur = navigation.addListener("blur", function() {
      cleanup === null || cleanup === void 0 ? void 0 : cleanup();
      cleanup = void 0;
      isFocused = false;
    });
    return function() {
      cleanup === null || cleanup === void 0 ? void 0 : cleanup();
      unsubscribeFocus();
      unsubscribeBlur();
    };
  }, [
    navigation,
    depsCountRef.current
  ]);
}
export {
  useFocusEffect
};
//# sourceMappingURL=useFocusEffect.js.map
